import { ThemeModule } from '../../front/lib/ThemeModule';
import { addLayoutResizeListener, removeLayoutResizeListener } from '../../front/lib/utils';
const FILTER_ALL = -1;
const FILTER_UNASSIGNED = 0;
export class Products extends ThemeModule {
    constructor() {
        super(...arguments);
        this.productEntries = this.querySelectorAll('[data-product-entry]').map(el => {
            return {
                el,
                data: (() => {
                    try {
                        return JSON.parse(el.dataset.productEntry);
                    }
                    catch (e) {
                        console.error(e);
                        return { primary_area: [], area: [], category: [] };
                    }
                })(),
            };
        });
        this.filters = new Proxy({ primary_area: FILTER_ALL, area: FILTER_ALL, category: FILTER_ALL }, {
            set: (target, key, value) => {
                target[key] = value;
                this.applyFilters(this.filters);
                return true;
            },
        });
        this.filterAdjustFns = {};
    }
    init() {
        this.applyFilters(this.filters);
        const clickHandler = (e) => {
            const target = e.target;
            const maybeBtn = (typeof target.closest === 'function')
                ? target.closest('a[data-filter], button[data-filter]')
                : null;
            if (maybeBtn) {
                e.preventDefault();
                const filterType = maybeBtn.dataset.filter;
                if (filterType) {
                    const value = Number(maybeBtn.dataset.filterValue);
                    this.filters[filterType] = value;
                    // Append link to the filter
                    const prevLink = this.getElementById(`${filterType}Link`);
                    const container = this.getElementById(`${filterType}Link-wrapper`);
                    if (prevLink) {
                        prevLink.parentElement.removeChild(prevLink);
                    }
                    if (value > 0 && maybeBtn instanceof HTMLAnchorElement && container) {
                        const link = document.createElement('a');
                        link.id = this.getId(`${filterType}Link`);
                        link.href = maybeBtn.href;
                        link.innerHTML = `<span>${this.json.strings['see_all_%s'].replace('%s', maybeBtn.innerText)}</span><span class="themeIcon themeIcon--arrow-right"></span>`;
                        container.appendChild(link);
                    }
                }
            }
        };
        this.root.addEventListener('click', clickHandler);
        this.addCleanupHandler(() => this.root.removeEventListener('click', clickHandler));
        this.querySelectorAll('.productsMod-filters').forEach(filterEl => {
            const buttonsEls = [].slice.apply(filterEl.querySelectorAll('[data-filter]'));
            const showAllEl = filterEl.querySelector('[data-filter-more]');
            showAllEl.addEventListener('click', e => {
                filterEl.classList.toggle('is--expanded');
            });
            const filterListAdjust = () => {
                const availableWidth = filterEl.scrollWidth;
                const gap = parseFloat(getComputedStyle(filterEl).getPropertyValue('gap')) || 0;
                let requiredWidth = showAllEl.offsetWidth + gap;
                let overflow = false;
                for (const btn of buttonsEls) {
                    if (!overflow) {
                        btn.classList.remove('is--overflown');
                        requiredWidth += btn.offsetWidth + gap;
                        if (requiredWidth > availableWidth) {
                            overflow = true;
                            btn.insertAdjacentElement('beforebegin', showAllEl);
                        }
                    }
                    if (overflow) {
                        btn.classList.add('is--overflown');
                    }
                }
                if (!overflow) {
                    showAllEl.classList.add('is--hidden');
                }
                else {
                    showAllEl.classList.remove('is--hidden');
                }
            };
            this.filterAdjustFns[filterEl.id] = filterListAdjust;
            filterListAdjust();
            addLayoutResizeListener(filterListAdjust);
            this.addCleanupHandler(() => removeLayoutResizeListener(filterListAdjust));
        });
    }
    adjustFiltersList(filter) {
        var _a, _b;
        if (filter) {
            (_b = (_a = this.filterAdjustFns)[filter]) === null || _b === void 0 ? void 0 : _b.call(_a);
        }
        else {
            for (const fn of Object.values(this.filterAdjustFns)) {
                fn();
            }
        }
    }
    applyFilters(filters) {
        const filtersArr = Object.entries(filters);
        const visibilities = [];
        for (const product of this.productEntries) {
            const { el, data } = product;
            let visibility = filtersArr.every(([key, value]) => {
                return value === FILTER_ALL || (data[key] && data[key].includes(Number(value)));
            });
            if (visibility) {
                el.classList.remove('is--hidden');
            }
            else {
                el.classList.add('is--hidden');
            }
            visibilities.push(visibility);
        }
        const relatedVisibility = {};
        for (const [key, value] of filtersArr) {
            this.root.querySelectorAll(`[data-filter="${key}"]`).forEach(el => {
                if (Number(el.dataset.filterValue) === Number(value)) {
                    this.applyActiveBtnStyles(el);
                    const relations = JSON.parse(el.dataset.relations || '{}');
                    // Construct visibility rules for the related filters
                    for (const [rel, ids] of Object.entries(relations)) {
                        if (!relatedVisibility[rel]) {
                            relatedVisibility[rel] = [];
                        }
                        if (value === FILTER_ALL) {
                            if (!relatedVisibility[rel].length) {
                                relatedVisibility[rel] = [-1];
                            }
                        }
                        else {
                            relatedVisibility[rel] = relatedVisibility[rel].filter(id => id !== -1);
                            for (const relId of ids) {
                                if (!relatedVisibility[rel].includes(relId)) {
                                    relatedVisibility[rel].push(relId);
                                }
                            }
                        }
                    }
                }
                else {
                    this.applyInactiveBtnStyles(el);
                }
            });
        }
        // Apply visibility rules for the related filters
        for (const key of Object.keys(relatedVisibility)) {
            this.root.querySelectorAll(`[data-filter="${key}"]`).forEach(el => {
                const filterValue = Number(el.dataset.filterValue);
                if (relatedVisibility[key].includes(-1) || filterValue === FILTER_ALL || relatedVisibility[key].includes(filterValue)) {
                    el.removeAttribute('disabled');
                }
                else {
                    el.setAttribute('disabled', 'disabled');
                }
            });
        }
        if (visibilities.every(v => v === false)) {
            this.root.classList.add('has--nothing');
        }
        else {
            this.root.classList.remove('has--nothing');
        }
        //this.adjustFiltersList();
    }
    applyActiveBtnStyles(el) {
        el.classList.remove('fill--outline', 'accentColor--dark');
        el.classList.add('is--active');
    }
    applyInactiveBtnStyles(el) {
        el.classList.add('fill--outline', 'accentColor--dark');
        el.classList.remove('is--active');
    }
}
